import { AddressDto } from '@/api';

function joinSafe(...values: string[]) {
  return values.map((it) => !it ? '' : it).join(' ');
}

export const Addresses = {
  emptyAddress() {
    return {
      salutation: '',
      telephone: '',
      company: '',
      street: '',
      streetNr: '',
      city: '',
      postCode: '',
      firstName: '',
      lastName: '',
      countryCode: 'AT',
    };
  },
  checkAddress(address: AddressDto): boolean {
    return address.countryCode === 'AT' &&
      !!address.firstName && !!address.lastName && !!address.postCode &&
      !!address.telephone && !!address.city && !!address.street && !!address.streetNr &&
      !!address.salutation;
  },
  toString(address: AddressDto | null): string {
    if (!address) {
      return '';
    }
    return [
      joinSafe(address.firstName, address.lastName),
      joinSafe(address.street, address.streetNr),
      joinSafe(address.postCode, address.city),
    ].join(', ');
  },
};
